/* eslint-disable i18next/no-literal-string */

const WRAPPER_SELECTOR = 'flags-sprite';

export const initializeSprite = (url: string) => {
  if (!document.getElementById(WRAPPER_SELECTOR)) {
    fetch(url)
      .then((result) => result.text())
      .then((content) => {
        const wrapper = Object.assign(document.createElement('div'), {
          id: WRAPPER_SELECTOR,
          innerHTML: content,
        });

        Object.assign(wrapper.style, {
          position: 'absolute',
          width: 0,
          height: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
        });

        document.body.prepend(wrapper);
      });
  }
};
